export default __webpack_public_path__ + "static/media/logo_placeholder.307ccb56.svg";